<template>
  <div class="modal-backdrop">
    <strategy-modal v-if='showColorChangeModal'
                    :occurredTaskId="currentOccurredTask"
                    :color="recommendedColorEntity"
                    @close="showColorChangeModal = false"
                    @changed="handleColorChange"

    />
    <div class="popup-content new-task-modal ">
      <button class="new-task-modal__close" type="button" @click="$emit('close')">
        ✕
      </button>

      <div v-if="!plannedTask">
        <h2 class="new-task-modal__title">Новая задача</h2>

        <div class="task-color-wrapper">
          <div class="tasks_wrapper">
            <p class="header_green">Какую задачу вам сейчас предстоит выполнить?</p>
            <div class="select_wrapper">
              <multiselect
                  :disabled="isTaskSet"
                  :options="taskOptions"
                  v-model="moodForm.task"
                  :allow-empty="false"
                  track-by="id" label="text"
                  aria-label="Выберите задачу"
                  placeholder="Выберите задачу"
                  selectedLabel="Выбрано"
                  deselectLabel=""
                  selectLabel=""
                  name="trigger_list"
              >
                <template #noOptions>
                Список загружается...
                </template>
              </multiselect>
            </div>
          </div>

          <ul class="color_list" v-if="!futureTask">
            <li v-for="(value, key) in colorsMap" :key="key">
              <div class="mood_color_block" :class="[{'active': value === activeColor}, key]"
                   @click="() => pickColor(value)"></div>
            </li>
          </ul>
        </div>

        <div v-if="moodForm.task && (!moodForm.color_id)" class="schedule-wrapper">
          <p class="header_green">Укажите время задачи</p>
          <task-schedule-picker v-model="moodForm.schedule" :initialDate="initialDate ?? null" :futureTask="futureTask" />
          <custom-textarea name="task-text" :label="'Описание задачи'" :height="100" v-model="moodForm.schedule.comment" />
        </div>
        <div v-if="moodForm.schedule?.isPlannedTask" class="planned-task-warning">
          <p class="header_green">
            Задача будет запланирована в календаре и вы сможете отметить эмоциональное состояние незадолго до её наступления.
          </p>
        </div>
      </div>

      <div v-else>
        <h2 class="new-task-modal__title">Запланированная задача</h2>

        <div>
          <div v-if="moodForm?.task?.text" class="planned-task-text">
            У вас запланированна задача "{{ moodForm.task.text }}", требующая определённого эмоционального состояния.
          </div>

          <div class="emotion-list">
            <div class="planned-task-text">
              <b>
                В каком квадрате вы находитесь?
              </b>
            </div>
            <ul class="color_list planned-list">
              <li v-for="(value, key) in colorsMap" :key="key">
                <div class="mood_color_block" :class="[{'active': value === activeColor}, key]"
                     @click="() => pickColor(value)"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="recommendationsLoaded">
        <div v-if="moodForm.color_id && appropriateMood" class='assessed_mood_wrapper'>
          <div>
            Вы в подходящем состоянии для этой задачи. Используйте его эффективно.
          </div>
        </div>

        <div v-if="moodForm.color_id && !appropriateMood" class='assessed_mood_wrapper'>
          <p>
            Ваше текущее эмоциональное состояние не способствует эффективному решению этой задачи
          </p>
          <p v-for="(item, key) in mismatchText" :key="key">{{ item }}</p>

          <div class="recommendation_wrapper">
            <div class="mood_recommendation">
              <div>
                <p>Если есть возможность, то рекомендуется сменить задачу на...</p>
                <div class="select_wrapper">
                  <multiselect
                      :options="appropriateTasks"
                      v-model="taskReplace"
                      :allow-empty="false"
                      track-by="id" label="text"
                      aria-label="Выберите задачу"
                      placeholder="Выберите задачу"
                      selectedLabel="Выбрано"
                      deselectLabel=""
                      selectLabel=""
                      name="filtered_tasks"
                  >
                    <template #noOptions>
                      Список загружается...
                    </template>
                  </multiselect>
                </div>
              </div>
              <button class="btn btn-accent" @click="replaceTask">Сменить задачу</button>
            </div>
            <div class="mood_recommendation">
              <p>
                {{ mismatchRecommendation }}
              </p>
              <button class="btn btn-accent" @click="replaceEmotion">Узнать как</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!recommendationsLoaded && moodForm.color_id" class="mini-loader">
        <mini-preloader />
      </div>

      <div class="modal-control">
        <div class="modal-control-button">
          <button class="btn btn-close" @click="$emit('close')">
            Закрыть
          </button>
        </div>
        <div class="modal-control-button" v-if="moodForm.schedule?.isPlannedTask">
          <button class="btn btn-accent" @click="setPlannedTask">
            Сохранить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatteryIndicator from './BatteryIndicator.vue'
import {computed, reactive} from "@vue/reactivity";
import {useStore} from "vuex";
import CustomSelect from "@/components/Forms/Fields/CustomSelect.vue";
import {onBeforeMount, onBeforeUnmount, ref, watch} from "@vue/runtime-core";
import Multiselect from "vue-multiselect";
import TaskSchedulePicker from "@/views/MoodTracker/MoodTrackerTaskSchedule.vue";
import textCard from "@/views/MoodTracker/colorCardText";
import CustomTextarea from "@/components/Forms/Fields/CustomTextarea.vue";
import CustomRadio from "@/components/Forms/Fields/CustomRadio.vue";
import {notify} from "@kyvg/vue3-notification";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";
import StrategyModal from "@/views/MoodTracker/MoodTrackerStrategyModal.vue";

export default {
  name: 'CurrentTaskForm',
  components: {
    StrategyModal,
    MiniPreloader,
    CustomRadio,
    CustomTextarea,
    TaskSchedulePicker,
    Multiselect,
    CustomSelect,
    BatteryIndicator,
  },
  emits: ['close', 'submitted'],
  props: {
    initialDate: {
      type: String,
      default: '',
    },
    plannedTask: {
      type: Object,
      default: null,
    },
    futureTask: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, context) {
    const store = useStore();
    const currentSettings = computed(() => store.state.tracker.settingsData);
    const batteryResetInterval = ref('weekly');
    const taskOptions = ref([]);
    const isLoading = ref(false);
    const isTaskSet = ref(false);
    const activeColor = ref('');
    const currentOccurredTask =  computed(() => store.state.tracker.currentOccurredTask);
    const taskOrEmotionWasChanged = ref(false);
    const recommendationsLoaded = ref(false);

    const moodForm = reactive({
      color_id: null,
      task_id: null,
      task: null,
      feedback_interval: null,
      schedule: {
        date: null,
        task_interval: null,
        repeat_type: null,
        comment: null,
      }
    });

    const colorList = computed(() => store.state.tracker.colorList);
    const taskList = computed(() => store.state.tracker.taskList);

    const colorBlocks = ref([
      {
        id: 1,
        image: require('@/assets/images/mood_tracker/red.svg'),
        title: 'Высокая энергия / неприятные ощущения',
        color: '#9c0130',
        open: false,
        block: 'red',
        block_type_translate: 'в красном квадрате',
        text: null,
        detailed: textCard.red.detailed,
        current: '',
      },
      {
        id: 2,
        image: require('@/assets/images/mood_tracker/yellow.svg'),
        title: 'Высокая энергия / приятные ощущения',
        color: '#ff9e02',
        open: false,
        block: 'yellow',
        text: null,
        block_type_translate: 'в желтом квадрате',
        detailed: textCard.yellow.detailed,
        current: '',
      },
      {
        id: 3,
        image: require('@/assets/images/mood_tracker/blue.svg'),
        title: 'Низкая энергия / неприятные ощущения',
        block_type_translate: 'в синем квадрате',
        color: '#100f76',
        open: false,
        block: 'blue',
        text: null,
        detailed: textCard.blue.detailed,
        current: '',
      },
      {
        id: 4,
        image: require('@/assets/images/mood_tracker/green.svg'),
        title: 'Низкая энергия / приятные ощущения',
        block_type_translate: 'в зеленом квадрате',
        color: '#3d9123',
        open: false,
        block: 'green',
        text: null,
        detailed: textCard.green.detailed,
        current: '',
      }
    ]);

    const colorsMap = {
      red: 'Красный',
      yellow: 'Жёлтый',
      blue: 'Синий',
      green: 'Зелёный',
    };

    const pickColor = (value) => {
      if (!moodForm.task) {
        notify({
          title: "Выберите задачу",
          type: "info"
        })
        return;
      }

      if (moodForm.color_id) {
        notify({
          title: "Нельзя изменить сделанный выбор",
          type: "info"
        })
        return;
      }

      if (moodForm.schedule?.isPlannedTask) {
        notify({
          title: "Нельзя отметить эмоции до наступления даты",
          type: "info"
        })
        return;
      }

      const color = colorList.value.find((el) => el.name === value);
      moodForm.color_id = color.id;
      activeColor.value = value;

      const currentColorKey = Object.keys(colorsMap).find(key => colorsMap[key] === value);

      activeBlock.value = colorBlocks.value.find((el) => el.block === currentColorKey);
    }

    onBeforeMount(async () => {
      isLoading.value = true;

      await store.dispatch('tracker/getTasks').then(() => {
        taskOptions.value = taskList.value.map((el) => {
          return {id: el.id, text: el.task};
        });
      });

      if (props.plannedTask) {
        setPlannedTaskForm();
      }

      await store.dispatch('tracker/getColors').then(() => {
        isLoading.value = false;
      });
    });

    onBeforeUnmount(() => {
      store.commit('tracker/clearCurrentOccurredTask');
    });

    const setPlannedTaskForm = () => {
      let taskData = taskList.value.find((el) => el.id === props.plannedTask.task.id);
      let date = props.plannedTask.interval.split('-');

      moodForm.task_id = props.plannedTask.task_id;
      moodForm.task = {id: taskData.id, text: taskData.task}
      moodForm.schedule.date = props.plannedTask.date;
      moodForm.schedule.start_time = date[0];
      moodForm.schedule.end_time = date[1];
      moodForm.schedule.task_interval = props.plannedTask.interval;
      moodForm.schedule.comment = props.plannedTask.comment;
    }

    const appropriateMood = ref();
    const recommendedColor = ref('');
    const recommendedColorEntity = ref(null);
    const mismatchText = ref();
    const mismatchRecommendation = ref();
    const appropriateTasks = ref([]);
    const activeBlock = ref();
    const taskReplace = ref();
    const showColorChangeModal = ref(false);

    const getRecommendation = () => {
      let taskColor = taskList.value.find((el) => el.id === parseInt(moodForm.task.id));
      recommendedColorEntity.value = colorList.value.find((el) => el.id === parseInt(taskColor.color_id));
      let recommendedColorKey = Object.keys(colorsMap).find(key => colorsMap[key] === recommendedColorEntity.value.name);

      appropriateMood.value = moodForm.color_id === taskColor.color_id;
      recommendedColor.value = recommendedColorEntity.value.name;

      mismatchText.value = textCard[activeBlock.value.block].mismatch[recommendedColorKey];
      mismatchRecommendation.value = textCard[recommendedColorKey].mismatch_recommendation;
      appropriateTasks.value = taskList.value.filter((task) => task.color_id === parseInt(moodForm.color_id)).map((el) => {
        return {id: el.id, text: el.task};
      });
    }

    watch(() => [moodForm.color_id, moodForm.task], async () => {
      taskReplace.value = null;
      recommendationsLoaded.value = false;

      if (moodForm.task && moodForm.color_id) {
        isTaskSet.value = true;

        if (!taskOrEmotionWasChanged.value) {
          await setOccurredTask();
        }

        getRecommendation();
        recommendationsLoaded.value = true;
      }
    });

    const setOccurredTask = async () => {
      const load = {
        planned_task_id: props.plannedTask?.planned_task_id ?? null,
        task_id: moodForm.task.id,
        color_id: moodForm.color_id,
        task_date: moodForm.schedule?.date,
        task_interval: moodForm.schedule?.start_time + '-' + moodForm.schedule?.end_time,
        repeat_type: moodForm.schedule?.repeat_type,
        comment: moodForm.schedule?.comment,
      };

      await store.dispatch('tracker/setOccurredTask', load).then(() => {
        context.emit('submitted');
      });
    }

    const setPlannedTask = () => {
      const load = {
        task_id: moodForm.task.id,
        initial_date: moodForm.schedule?.date,
        initial_interval: moodForm.schedule?.start_time + '-' + moodForm.schedule?.end_time,
        reoccurrence_interval: moodForm.schedule?.repeat_type,
        comment: moodForm.schedule?.comment,
      };

      store.dispatch('tracker/setPlannedTask', load).then(() => {
        notify({
          title: "Задача сохранена",
          type: "info"
        })
        context.emit('submitted');
        context.emit('close');
      });
    }

    const replaceTask = () => {
      moodForm.task = taskReplace.value;
      replaceEmotionOrTask('task', taskReplace.value.id);
    }

    const replaceEmotion = () => {
      replaceEmotionOrTask('color', recommendedColorEntity.value.id);
      showColorChangeModal.value = true;
    }

    const replaceEmotionOrTask = (type, id) => {
      taskOrEmotionWasChanged.value = true;

      store.dispatch('tracker/changeEmotionOrTask', {
        id: currentOccurredTask.value,
        type: type,
        replacement_id: id,
      }).then(() => {
        getRecommendation();
        context.emit('submitted');
      });
    }

    const handleColorChange = () => {
      moodForm.color_id = recommendedColorEntity.value.id;
      showColorChangeModal.value = false;
    }

    return {
      currentSettings,
      batteryResetInterval,
      moodForm,
      taskOptions,
      isTaskSet,
      colorsMap,
      pickColor,
      activeColor,
      appropriateMood,
      mismatchText,
      mismatchRecommendation,
      appropriateTasks,
      taskReplace,
      setPlannedTask,
      replaceEmotionOrTask,
      replaceTask,
      recommendationsLoaded,
      replaceEmotion,
      handleColorChange,
      showColorChangeModal,
      currentOccurredTask,
      recommendedColorEntity,
    }
  },
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  display: flex;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.new-task-modal {
  position: relative;
  width: 900px;
  max-width: 100%;
  background: #f3f3f3;
  border-radius: 26px;
  padding: 26px 34px 28px;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  margin: auto 0;
}

.new-task-modal .form-group {
  font-size: 16px;
  font-weight: 600;
}

@media (min-width: 901px) {
  .modal-backdrop {
    align-items: center;
  }
}

@media (max-width: 900px) {
  .modal-backdrop {
    align-items: flex-start;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .new-task-modal {
    margin: 0;
    border-radius: 20px;
  }
}

.new-task-modal__close {
  position: absolute;
  top: 18px;
  right: 18px;
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #8f8f8f;
  cursor: pointer;
  padding: 0;
}

.new-task-modal__title {
  margin: 0 0 18px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
}

.tasks_wrapper .form-group {
  justify-content: flex-start;
}

.header_green {
  font-size: 18px;
  font-weight: bold;
  color: #51bb50;
}

.select_wrapper {
  margin: 10px 0;
  width: 80%;

  @media (max-width: 900px) {
    width: 100%;
  }
}

.schedule-wrapper {
  margin: 30px 0;

  p {
    margin-bottom: 15px;
  }

  .form-group {
    font-size: 14px;
    margin-top: 0;
  }
}

.modal-control {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  .btn {
    border-radius: 6px;
  }
}

.color_list {
  margin: 20px 0;
  display: flex;
  column-gap: 10px;
}

.mood_color_block {
  width: 60px;
  height: 80px;
  cursor: pointer;
  position: relative;
}

.mood_color_block:hover {
  opacity: 0.9;
}

.mood_color_block.yellow {
  background-image: linear-gradient(rgba(255, 236, 138, 0.6), rgba(255, 236, 138, 0.6)), url("../../assets/images/yellow-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #ffec8a;
}

.mood_color_block.green {
  background-image: linear-gradient(rgba(176, 220, 156, 0.6), rgba(176, 220, 156, 0.6)), url("../../assets/images/green-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #b0dc9c;
}

.mood_color_block.blue {
  background-image: linear-gradient(rgba(130, 152, 204, 0.6), rgba(130, 152, 204, 0.6)), url("../../assets/images/blue-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #8298cc;
}

.mood_color_block.red {
  background-image: linear-gradient(rgba(242, 145, 117, 0.6), rgba(242, 145, 117, 0.6)), url("../../assets/images/red-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #f29175;
}

.color_text {
  font-weight: bold;
}

.text_yellow {
  color: #ffec8a;
}

.text_green {
  color: #b0dc9c;
}

.text_blue {
  color: #8298cc;
}

.text_red {
  color: #f29175;
}

.active::after {
  content: "✓";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 80px;
  color: #00e287;
  pointer-events: none;
}

.red.active {
  background-image: url("../../assets/images/mood_tracker/red.svg");
}

.green.active {
  background-image: url("../../assets/images/mood_tracker/green.svg");
}

.blue.active {
  background-image: url("../../assets/images/mood_tracker/blue.svg");
}

.yellow.active {
  background-image: url("../../assets/images/mood_tracker/yellow.svg");
}

.task-color-wrapper {
  display: flex;
  gap: 16px;
  justify-content: space-between;

  @media (max-width: 930px) {
    flex-direction: column;
  }
}

.assessed_mood_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 20px;

  @media (max-width: 900px) {
    padding: 20px 0;
  }
}

.save_button_wrapper {
  display: flex;
  justify-content: end;
  padding: 10px 20px;
}

.recommendation_wrapper {
  display: flex;
  column-gap: 15px;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 700px) {
    flex-direction: column;
    gap: 16px;
  }
}

.mood_recommendation {
  display: flex;
  flex-direction: column;
  padding: 20px;
  row-gap: 20px;
  width: 48%;
  min-height: 350px;
  font-size: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  justify-content: space-between;

  @media (max-width: 700px) {
    width: 100%;
  }
}

.mini-loader {
  text-align: center;
  padding: 40px 0;
}

.planned-task-text {
  margin-bottom: 16px;
  font-size: 18px;
  text-align: center;

  b {
    font-weight: bold;
  }
}

.planned-list.color_list {
  justify-content: center;
}

:deep(.multiselect--disabled .multiselect__select) {
  background-color: #ffffff;
}
</style>